module.exports = __webpack_public_path__ + "img/html.997d401f.svg";